module.exports = __webpack_public_path__ + "static/img/click_commonly_used.713b76d4.png";